
import type { Product } from './types';

export const liquimolyProducts: Product[] = [
  {
    id: 'p4',
    shopId: '',
    name: 'Liqui Moly Leichtlauf 10W-40',
    brand: 'liqi moly',
    price: 150,
    image: '/lovable-uploads/1bf3775e-431a-4813-a332-79f702e0cf9f.png',
    description: 'Semi-synthetic low-friction oil for gasoline/diesel engines.',
    category: 'oil',
  },
  {
    id: 'p7',
    shopId: '',
    name: 'Top Tec 4200 5W-30 New Generation',
    brand: 'liqi moly',
    price: 180,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/8/9/8972_Top_Tec_4200_5W_30_New_Generation_1l_7051.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'Low-friction oil for modern gasoline/diesel engines.',
    category: 'oil',
  },
  {
    id: 'msc6',
    shopId: '',
    name: 'Top Tec 4100 5W-40',
    brand: 'liqi moly',
    price: 170,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/2/0/20697_Top_Tec_4100_5W_40_4l_c359.jpg?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'High-performance engine oil Top Tec 4100 5W-40.',
    category: 'oil',
  },
  {
    id: 'msc7',
    shopId: '',
    name: 'Top Tec 4310 0W-30',
    brand: 'liqi moly',
    price: 200,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/2/3/2361_Top_Tec_4310_0W_30_1l_a5ee.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'Fully synthetic low-viscosity engine oil 0W-30.',
    category: 'oil',
  },
  {
    id: 'msc4',
    shopId: '',
    name: 'Top Tec 4200 5W-30 New Generation',
    brand: 'liqi moly',
    price: 180,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/8/9/8972_Top_Tec_4200_5W_30_New_Generation_1l_7051.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'Low-friction oil for modern gasoline/diesel engines.',
    category: 'oil',
  },
  {
    id: 'msc5',
    shopId: '',
    name: 'Leichtlauf 10W-40',
    brand: 'liqi moly',
    price: 150,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/2/8/28107b9ffaa111d003c2ea6d796e24a3d1408056_9500_Leichtlauf_10W_40_1l_3358.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'Semi-synthetic low-friction oil for gasoline/diesel engines.',
    category: 'oil',
  },
  {
    id: 'msc6',
    shopId: '',
    name: 'Top Tec 4100 5W-40',
    brand: 'liqi moly',
    price: 170,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/2/0/20697_Top_Tec_4100_5W_40_4l_c359.jpg?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'High-performance engine oil Top Tec 4100 5W-40.',
    category: 'oil',
  },
  {
    id: 'msc7',
    shopId: '',
    name: 'Top Tec 4310 0W-30',
    brand: 'liqi moly',
    price: 200,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/2/3/2361_Top_Tec_4310_0W_30_1l_a5ee.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'Fully synthetic low-viscosity engine oil 0W-30.',
    category: 'oil',
  },
  {
    id: 'msc8',
    shopId: '',
    name: 'Gasoline Engine System Cleaner',
    brand: 'liqi moly',
    price: 50,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/9/e/9e749fc09114b5cb9b1741b4b7bdcc00f82136c3_21624_Motorsystemreiniger_Benzin_300ml_4130.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'Cleaner for gasoline engine systems.',
    category: 'additive',
  },
  {
    id: 'msc9',
    shopId: '',
    name: 'Pro-Line Engine Flush',
    brand: 'liqi moly',
    price: 70,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/0/1/01858577b31f9ba046126b19c580d5d651861bc0_2427_Pro_Line_Motorsp__lung_500ml_905e.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal',
    description: 'Flushes out and cleans the oil circuit of engines.',
    category: 'additive',
  },
];
